import { useState } from "react";
import { entranceItems } from "@/mocks/comicData";

const levelClass: Record<string, string> = {
  primary: "border-primary-200 bg-primary-50",
  accent: "border-accent-200 bg-accent-50",
  secondary: "border-secondary-200 bg-secondary-50",
};

const iconClass: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

const tagClass: Record<string, string> = {
  primary: "bg-primary-500 text-background-50",
  accent: "bg-accent-500 text-background-50",
  secondary: "bg-secondary-500 text-background-50",
};

export default function Entrance() {
  const [copied, setCopied] = useState<string | null>(null);

  const copy = async (domain: string, name: string) => {
    try {
      await navigator.clipboard.writeText(domain);
      setCopied(name);
      setTimeout(() => setCopied(null), 1800);
    } catch {
      setCopied(name);
      setTimeout(() => setCopied(null), 1800);
    }
  };

  return (
    <section id="entrance" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mx-auto mb-12 max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
            <i className="ri-door-open-line" />
            访问入口
          </span>
          <h2 className="font-heading mt-4 text-3xl text-foreground-950 md:text-4xl">
            最新可用的入口地址
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            主站优先，备用兜底。点击地址即可一键复制，把最新入口加入收藏，随时快速进入阅读。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {entranceItems.map((item) => (
            <div
              key={item.domain}
              className={`flex flex-col rounded-lg border p-5 ${levelClass[item.level]}`}
            >
              <div className="flex items-center justify-between">
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-md ${iconClass[item.level]}`}
                >
                  <i className={`${item.icon} text-xl`} />
                </span>
                <span
                  className={`rounded-full px-2.5 py-1 text-xs font-bold ${tagClass[item.level]}`}
                >
                  {item.tag}
                </span>
              </div>

              <h3 className="mt-4 text-base font-bold text-foreground-950">{item.name}</h3>
              <p className="mt-1 text-sm font-medium text-primary-700 md:text-base">
                {item.domain}
              </p>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{item.note}</p>

              <button
                type="button"
                onClick={() => copy(item.domain, item.name)}
                className="mt-4 inline-flex items-center justify-center gap-2 rounded-md bg-background-50 px-4 py-2.5 text-sm font-bold text-foreground-900 whitespace-nowrap border border-background-200 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                {copied === item.name ? (
                  <>
                    <i className="ri-check-line" />
                    已复制
                  </>
                ) : (
                  <>
                    <i className="ri-file-copy-line" />
                    复制地址
                  </>
                )}
              </button>
            </div>
          ))}
        </div>

        <p className="mt-6 text-center text-xs text-foreground-500 md:text-sm">
          地址如遇调整，本页会第一时间同步更新，建议收藏本页以便随时获取最新入口。
        </p>
      </div>
    </section>
  );
}